import type {PropsWithChildren, ReactNode} from 'react';
import {BookmarkTabsList} from '../bookmark-tabs';
import {cn} from '../lib/cn';
import {Tabs} from '../tabs';

export interface TabbedSectionProps extends PropsWithChildren {
  className?: string;
  triggers: ReactNode;
  value?: string;
  defaultTab?: string;
  onTabChange?: (value: string) => void;
  variant?: 'default' | 'material';
}

export function TabbedSection({
  triggers,
  value,
  defaultTab,
  onTabChange,
  children,
  className,
  variant = 'default',
}: TabbedSectionProps) {
  const activeTab = value || defaultTab;

  const contentContainerClassName =
    variant === 'material'
      ? cn(
          'border-0 bg-transparent p-0 pt-6 shadow-none',
          '[&>div:first-child]:flex [&>div:first-child]:flex-col',
          '[&>div:first-child]:gap-[var(--section-gap,0.75rem)]',
          className,
        )
      : cn(
          'rounded-b-md border border-t-0 border-[var(--chekin-color-gray-3)] bg-[var(--chekin-color-white)] p-6 shadow-none',
          '[&>div:first-child]:flex [&>div:first-child]:flex-col',
          '[&>div:first-child]:gap-[var(--section-gap,0.75rem)]',
          className,
        );

  return (
    <Tabs value={activeTab} onValueChange={onTabChange} className="w-full">
      <BookmarkTabsList
        variant={variant}
        className={cn('w-full justify-start bg-transparent p-0')}
      >
        {triggers}
      </BookmarkTabsList>

      <div className={contentContainerClassName}>{children}</div>
    </Tabs>
  );
}
